import { Link, useNavigate } from "react-router-dom";
import { PasswordHideIcon } from "../../Assets/icons/PasswordHideIcon";
import { PasswordShowIcon } from "../../Assets/icons/PasswordShowIcon";
import { BackArrowIcon } from "../../Assets/icons/BackArrowIcon";
import logo from "../../Assets/images/logo.png";
import { useState } from "react";
import { authService } from "../../services/authServices";

export const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    remember: false,
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.username.trim()) {
      newErrors.username = "Username is required";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      await authService.login(formData.username, formData.password);
      if (formData.remember) {
        localStorage.setItem("remember_user", formData.username);
      } else {
        localStorage.removeItem("remember_user");
      }
      navigate("/");
    } catch (error) {
      const errorMessage = error.response?.data?.message?.error || error.response?.data?.message;
      const code = error.response?.data?.code || error.response?.status;
      if (code === 400) {
        setErrors({
          api: errorMessage,
        });
      } else if (code === 417) {
        navigate(`/otp-verification?email=${formData.username}&type=signup`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="main min-vh-100 d-flex justify-content-center flex-row w-100 authmain">
        <div className="authcard">
          <div className="w-100 text-center">
            <a href="http://iris-solar.com/" className="authlogo">
              <img src={logo} width={337} height={90} alt="logo" />
            </a>
          </div>
          <div className="authcardmain">
            {/* <div className="authcardheader">
              <span className="font-30 white-font fw-bold mb-3 d-inline-block">
                Hello!
              </span>
              <p className="white-font fw-medium h_2 authcardsubtitle">
                We are really happy to see you again
              </p>
            </div> */}
            <form className="authform pt-3" onSubmit={handleSubmit}>
              <div className="form-group mb-3 pb-1">
                <input
                  type="text"
                  name="username"
                  className={`form-control`}
                  placeholder="Enter Email"
                  value={formData.username}
                  onChange={handleInputChange}
                />
                {errors.username && (
                  <span className="required-text">{errors.username}</span>
                )}
              </div>
              <div className="form-group password-group position-relative mb-2">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className={`form-control`}
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleInputChange}
                />
                <span
                  className="pswd-hide-show cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <PasswordShowIcon /> : <PasswordHideIcon />}
                </span>
                {errors.password && (
                  <span className="required-text">{errors.password}</span>
                )}
                {errors.api && (
                  <span className="required-text">{errors.api}</span>
                )}
              </div>
              <div className="d-flex align-items-center mb-4 pt-1 justify-content-between">
                <div className="form-check-group">
                  <input
                    className="form-checkbox"
                    id="remember"
                    name="remember"
                    type="checkbox"
                    checked={formData.remember}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="remember" className="white-font">
                    Remember me
                  </label>
                </div>
                <Link
                  to="/forgot-password"
                  className="font-12 fw-normal primary-font"
                >
                  Forgot Password?
                </Link>
              </div>
              <button
                type="submit"
                className="btn-primary-custom w-100"
                disabled={loading}
              >
                {loading ? "Signing in..." : "Sign In"}
              </button>
              <div className="text-center mt-4">
                <span className="white-font fw-medium h_5">
                  Don't have an account?{" "}
                </span>
                <Link
                  to="/signup"
                  className="font-12 fw-normal primary-font"
                >
                  Sign Up
                </Link>
              </div>
              <div className="d-flex align-items-center mt-4 justify-content-center">
                <a href="http://iris-solar.com/" className="font-12 fw-normal primary-font">
                  <BackArrowIcon className="me-2" />
                  Back to Homepage
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
